(() => {
new Vue({
    el: "#app",
    data () {
        return {
            premiumPartners: [],
            partners: [],
            lang: document.documentElement.lang
        };
    },
    mounted () {
        axios.get(`/api/partners`).then((response)=>{
            this.partners = response.data.filter((p)=>!p.premium);
            this.premiumPartners = response.data.filter((p)=>p.premium);
            this.lang = document.documentElement.lang;
        }).catch((error)=>{
            console.log(error);
            this.partners = [];
        });
    }
});

})();
//# sourceMappingURL=partners.js.map
